import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": e => e.preventDefault()
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_vm.editModel ? _c(VRow, {
    staticClass: "twin-metainfo-form"
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "input_view_title",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.enterTwinTitle'),
      "color": _vm.color,
      "rules": [v => !!v && v.trim() !== '' || _vm.$i18n_t('Common.fieldRequired')],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "clearable": "",
      "required": ""
    },
    model: {
      value: _vm.editModel.title,
      callback: function ($$v) {
        _vm.$set(_vm.editModel, "title", $$v);
      },
      expression: "editModel.title"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.titleDigitalTwinHint')))])], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-account-selector', {
    attrs: {
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.editModel.tenantId,
      callback: function ($$v) {
        _vm.$set(_vm.editModel, "tenantId", $$v);
      },
      expression: "editModel.tenantId"
    }
  })], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VRow, [_c(VCol, [_vm.markdownEdit ? _c(VCard, {
    staticClass: "elevation-0 v-card-text-area mdbox",
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.editModel.description || ''
    }
  })], 1)], 1) : _c(VCard, [_c(VTextarea, {
    attrs: {
      "data-cy": "input_view_description",
      "label": _vm.$i18n_t('Common.description'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rows": "7",
      "hide-details": "auto",
      "clearable": ""
    },
    model: {
      value: _vm.editModel.description,
      callback: function ($$v) {
        _vm.$set(_vm.editModel, "description", $$v);
      },
      expression: "editModel.description"
    }
  })], 1)], 1)], 1), _c(VSwitch, {
    staticClass: "switch-dense",
    attrs: {
      "label": _vm.$i18n_t('Common.mdeditor'),
      "color": _vm.color
    },
    model: {
      value: _vm.markdownEdit,
      callback: function ($$v) {
        _vm.markdownEdit = $$v;
      },
      expression: "markdownEdit"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "my-0 pt-0"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.searchConfig')))]), _c('p', {
    staticClass: "card-description mt-1"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.searchConfigText')) + "\n      ")]), _c('MultiSearch', {
    ref: "multiSearch",
    attrs: {
      "data-cy": "multi-search",
      "search-config": _vm.searchConfig,
      "show-condition": "",
      "show-operator": ""
    },
    on: {
      "search-updated": _vm.onSearchUpdate
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.packetMonitoring')))]), _c('p', {
    staticClass: "card-description mt-1 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.packetMonitoringText')) + "\n      ")]), _c(VSwitch, {
    attrs: {
      "color": _vm.color,
      "inset": "",
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.packetMonitoringIsActive'),
      "hide-details": ""
    },
    model: {
      value: _vm.editModel.meta.monitoring.isActive,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta.monitoring, "isActive", $$v);
      },
      expression: "editModel.meta.monitoring.isActive"
    }
  })], 1), _c('div', {
    staticClass: "mx-4 my-1",
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": !_vm.editModel.meta.monitoring.isActive,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.threshold'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.editModel.meta.monitoring.isActive ? _vm.requiredRule : [],
      "hide-details": "auto",
      "clearable": "",
      "type": "number"
    },
    on: {
      "input": e => {
        _vm.editModel.meta.monitoring.threshold = parseInt(e);
      }
    },
    model: {
      value: _vm.editModel.meta.monitoring.threshold,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta.monitoring, "threshold", $$v);
      },
      expression: "editModel.meta.monitoring.threshold"
    }
  }), _c(VSelect, {
    staticClass: "mx-2",
    attrs: {
      "disabled": !_vm.editModel.meta.monitoring.isActive,
      "items": _vm.packetMonitoringInterval,
      "item-text": "text",
      "item-value": "value",
      "label": _vm.$i18n_t('Common.chartOptions.interval'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "rules": _vm.editModel.meta.monitoring.isActive ? _vm.requiredRule : [],
      "hide-details": "auto"
    },
    model: {
      value: _vm.editModel.meta.monitoring.interval,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta.monitoring, "interval", $$v);
      },
      expression: "editModel.meta.monitoring.interval"
    }
  }), _c(VSelect, {
    staticClass: "mx-2",
    attrs: {
      "disabled": !_vm.editModel.meta.monitoring.isActive,
      "items": [{
        value: 'warning',
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
      }, {
        value: 'error',
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
      }],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.editModel.meta.monitoring.isActive ? _vm.requiredRule : [],
      "label": _vm.$i18n_t('AlarmLogs.table.headers.severity'),
      "hide-details": "auto"
    },
    model: {
      value: _vm.editModel.meta.monitoring.thresholdSeverity,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.meta.monitoring, "thresholdSeverity", $$v);
      },
      expression: "editModel.meta.monitoring.thresholdSeverity"
    }
  })], 1)], 1) : _vm._e(), _vm.editModel ? _c(VRow, {
    staticClass: "twin-metainfo-form"
  }, [_c(VCol, {
    staticClass: "mt-4",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.attachments')))]), _c('p', {
    staticClass: "card-description mt-1 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.detailView.attachmentsText')) + "\n      ")]), _c('br'), _c('core-dtwin-attachments', {
    attrs: {
      "attachments": _vm.editModel.meta && _vm.editModel.meta.attachments || [],
      "selectedAttachments": _vm.selectedAttachments
    },
    on: {
      "update": _vm.attachmentsUpdated,
      "image-selected": _vm.viewImageSelected,
      "image-deselected": _vm.viewImageDeselected
    },
    scopedSlots: _vm._u([{
      key: "additional",
      fn: function () {
        return [_c(VRow, {
          staticClass: "ma-0 pa-0"
        }, [_c(VCol, {
          attrs: {
            "cols": "12",
            "sm": "6"
          }
        }, [_vm.viewImages.length > 1 ? _c(VSelect, {
          attrs: {
            "items": _vm.viewImages,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.metaInfo.backgroundImage'),
            "item-value": "id",
            "item-text": "name"
          },
          model: {
            value: _vm.editModel.meta.viewImageId,
            callback: function ($$v) {
              _vm.$set(_vm.editModel.meta, "viewImageId", $$v);
            },
            expression: "editModel.meta.viewImageId"
          }
        }) : _vm._e()], 1)], 1)];
      },
      proxy: true
    }], null, false, 2006251856)
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };